/**
 * Шрифты дизайн-системы SamVision (`ui-kit/src/styles/fonts.css`), собранные как
 * нативные ассеты.
 *
 * Два семейства — те же, что у рабочей станции и у витрины ui-kit:
 *
 * - **Play** — шрифт интерфейса. Логотип набран широким гротеском в духе Eurostile, и
 *   Play повторяет его квадратные скругления точнее всех семейств с кириллицей,
 *   оставаясь читаемым в таблице на 12–13 px. Начертаний два: обычное и жирное.
 *   «Средний» вес отдаётся обычному, «полужирный» — жирному: имена остаются, чтобы
 *   компоненты говорили о смысле веса, а не о его номере.
 * - **JetBrains Mono** — номера, суммы, время: там, где символы сверяют по одному,
 *   ширина у всех должна быть одна.
 *
 * Оба по SIL OFL (лицензии рядом с файлами в `assets/fonts`). ui-kit поставляет их
 * как woff2 — формат, который Android не грузит, — поэтому здесь лежат TTF тех же
 * семейств: Play с Google Fonts, JetBrains Mono из релиза JetBrains.
 *
 * На Android имя семейства — это имя файла без расширения: `Play-Bold` →
 * android/app/src/main/assets/fonts/Play-Bold.ttf.
 *
 * НИКОГДА не сочетать с `fontWeight`. ReactFontManager (ReactAndroid .../assets/
 * ReactFontManager.kt) превращает fontWeight >= 700 в суффикс `_bold` в ИМЕНИ ФАЙЛА,
 * ищет `Play-Bold_bold.ttf`, не находит и молча откатывается на
 * `Typeface.create(name, style)` — то есть на системную Roboto. Ни исключения, ни
 * предупреждения: просто не тот шрифт на экране. Каждый файл уже несёт свой вес:
 * выбирается файл, `fontWeight` не задаётся.
 */
export const fonts = {
  sans: {
    regular: 'Play-Regular', // 400
    /** У Play нет среднего начертания — «средний» это обычный, как в ui-kit. */
    medium: 'Play-Regular', // 400
    semibold: 'Play-Bold', // 700
    bold: 'Play-Bold', // 700
  },
  mono: {
    regular: 'JetBrainsMono-Regular', // 400
    medium: 'JetBrainsMono-Medium', // 500
  },
  /**
   * Иконочный шрифт — Lucide, набор shadcn/ui, вырезанный до глифов, которые кабинет
   * называет по имени (`tools/lucide-font.cjs`). Семейство в файле — «lucide», и
   * Android ищет `assets/fonts/lucide.ttf` по этому же имени.
   */
  icon: 'lucide',
} as const;

/** Every family bundled in assets/fonts — the linker's manifest, and what tests assert against. */
export const BUNDLED_FONT_FAMILIES: readonly string[] = [
  fonts.sans.regular,
  fonts.sans.bold,
  fonts.mono.regular,
  fonts.mono.medium,
  fonts.icon,
];
